import { z } from "zod";

export const academyFormSchema = z.object({
  academyCampId: z.string(),
  answers: z.array(
    z.object({
      id: z.string(),
      value: z.string().min(1),
    }),
  ),
  consent: z.boolean().refine((val) => val === true, { message: "Bu alan zorunludur" }),
});

export type AcademyFormModel = z.infer<typeof academyFormSchema>;
